import React from 'react';
import { Typography } from '@packages/ui/primitives';
import type { FormCustomRenderer } from '../types/renderer';
import { FormScrollAgreementRenderer } from './FormScrollAgreementRenderer';

export const ScrollAgreementCustomRenderer: FormCustomRenderer = function ScrollAgreementCustomRenderer({
  props,
  control,
}) {
  const content = typeof props.content === 'string' ? props.content : '';
  const name = typeof props.name === 'string' ? props.name : undefined;

  return (
    <FormScrollAgreementRenderer
      content={content}
      name={name}
      control={control as never}
    />
  );
};

function createPlaceholderRenderer(rendererKey: string): FormCustomRenderer {
  return function PlaceholderRenderer() {
    return (
      <Typography variant='body-s' color='var(--ui-text-muted)'>
        [{rendererKey}] custom renderer — register via FormRenderer customRenderers prop.
      </Typography>
    );
  };
}

/** Default custom renderer registration points (D11c, D11d, D11j). */
export const defaultCustomRenderers: Record<string, FormCustomRenderer> = {
  'scroll-agreement': ScrollAgreementCustomRenderer,
  'rule-summary': createPlaceholderRenderer('rule-summary'),
  'rule-builder': createPlaceholderRenderer('rule-builder'),
  'inline-table': createPlaceholderRenderer('inline-table'),
};
